import { onClick } from '../utils';

/**
 * # Uniform select menu
 *
 * A custom select menu that displays differently from the browser `<select>`
 * menu
 *
 * ## Usage
 *
 * ```
 * <uniform-select>
 *   <select-title>
 *     Current item
 *   </select-title>
 *   <menu>
 *     <item>
 *       item 1
 *     </item>
 *     <item>
 *       item 2
 *     </item>
 *     <item>
 *       item 3
 *     </item>
 *   </menu>
 * </uniform-select>
 * ```
 */
export default class SelectComponent extends window.HTMLElement {
    constructor () {
        super();

        // prevent multiple event listener register when moving the element around(eg: open/close modal) 
        this.init = false;
        setTimeout(() => {
            if (!this.init) {
                // add event listener under body to close select menu
                onClick(this.querySelector('select-title'), this.toggle.bind(this));
                onClick(document.querySelector('body'), this.close.bind(this));
                this.init = true;
            }
        }, 0)
    }

    get multiple () {
        return this.hasAttribute('multiple') && this.getAttribute('multiple') === 'true';
    }
    set multiple (val) {
        if (val) {
            this.setAttribute('multiple', 'true');
        } else {
            this.removeAttribute('multiple');
        }
    }

    close () {
        this.classList.remove('open');
    }

    open () {
        this.classList.add('open');
    }

    toggle () {
        const currentSelect = this.classList.contains('open');
        // Close any open select menus
        const selects = [...document.querySelectorAll('uniform-select.open'), ...document.querySelectorAll('edlio-select.open')];

        selects
            .forEach((select) => {
                select.classList.remove('open');
            });

        if (!currentSelect) {
            this.classList.add('open');
        }
    }

    connectedCallback () {
        // Observer for child node changes for framework that dynamically add
        // child node with their templating.  With each new node being added,
        // we want to close the select menu when this select menu does not
        // allow multiple
        const observer = new MutationObserver(mutations => {
            if (this.allowMultiple) {
                return;
            }
            mutations.forEach(mutation => {
                Array.prototype.slice.call(mutation.addedNodes)
                    .filter(n => n.nodeName === 'ITEM')
                    .forEach(node => {
                            onClick(node, this.close.bind(this));
                            return;
                    });
            });
        });
        var config = { childList: true };
        observer.observe(this, config);
        // add event listener to existing select-items
        [...this.querySelectorAll('item')]
            .forEach(n => {
                onClick(n, this.close.bind(this));
            });
    }
};


// WEBPACK FOOTER //
// ./src/js/components/select.js